import { render, staticRenderFns } from "./quotaIms.vue?vue&type=template&id=57f8fff6&scoped=true&"
import script from "./quotaIms.vue?vue&type=script&lang=js&"
export * from "./quotaIms.vue?vue&type=script&lang=js&"
import style0 from "./quotaIms.vue?vue&type=style&index=0&id=57f8fff6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f8fff6",
  null
  
)

export default component.exports